
import { Component, Vue, Prop } from 'vue-property-decorator'
import { auditExOrder } from '@/api/task/exOrder'
import { setAuditStatusRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'
import { getOrderList } from '@/api/order/deposit'
import { AppModule } from '@/store/modules/app'
import { getTransaction } from '@/api/merchant/fund'

@Component({
  name: 'review',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  get language() {
    return AppModule.language
  }
  private statusList: any[] = []
  private setForm: any = {
    status: null,
    reason: '',
    ordernumber: null,
    merchant_no: null,
    callback_amount: ''
  }
  queryForm: any = {
    id: ''
  }

  private merchantRef: any = ''

  private rules = setAuditStatusRules
  private loading: boolean = false
  private infoLoading: boolean = false
  private lastTime: any = 0
  private eventSelect: any = null
  private dialogStatement: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 点击清空选项的按钮
  private emptyOption() {
    this.eventSelect = null
    this.setForm.ordernumber = null
    this.setForm.merchant_no = null
  }

  // 选择商户订单号处理，获取平台订单号必选项
  private orderRef: any = null
  private getOrderNo(v) {
    this.orderRef = v
  }

  // 切换处理方式
  private selectEvent: any = null
  private eventChange(v) {
    this.selectEvent = v
    this.setForm.ordernumber = null
    this.setForm.merchant_no = null
    this.merchantRef = null
    this.orderInfo = []
  }

  private back() {
    this.setForm = {
      status: null,
      reason: '',
      ordernumber: null,
      callback_amount: ''
    }
    this.$emit('close')
  }

  private orderInfo: any = []
  private async getOrderInfo() {
    try {
      this.loading = true
      if (this.merchantRef !== '') {
        const data: any = {
          currency: AppModule.currentCurrencyType,
          order_number: this.merchantRef,
          status: this.info.status
        }
        delObjEmptyKey(data)
        await getOrderList(data).then((res: any) => {
          this.orderInfo = res.results
          if (this.orderInfo.length === 1) {
            this.setForm.ordernumber = this.orderInfo[0].ordernumber
          } else {
            this.setForm.ordernumber = this.setForm.ordernumber
          }
          this.loading = false
        })
      }
    } catch (e) {
      this.loading = false
    }
  }
  // 清空已获取的订单信息
  private initEmpty() {
    this.orderRef = null
    this.setForm.ordernumber = null
    this.getOrderInfo()
  }

  private async auditOrder() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        let data: any = {}
        if (this.info.approvalTtype === 'callback') {
          data = {
            task_id: this.info.id,
            status: this.setForm.status,
            ordernumber: this.setForm.ordernumber,
            callback_amount: this.setForm.callback_amount
          }
        } else {
          data = {
            task_id: this.info.id,
            status: this.setForm.status,
            reason: this.setForm.reason
          }
        }
        try {
          await auditExOrder(data).then((res: any) => {
            if (this.language === 'en') {
              this.$message({
                message: 'Operation is successful!',
                type: 'success'
              })
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '操作成功!',
                type: 'success'
              })
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '操作成功!',
                type: 'success'
              })
            }
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private select() {
    this.getMerchantFundInfo()
  }

  private reset() {
    this.queryForm = {
      id: ''
    }
    this.getMerchantFundInfo()
  }

  private confirmInfo() {
    this.dialogStatement = false
    this.back()
  }

  private configID: any = null
  private async balanceAudit() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          task_id: this.info.id,
          status: this.setForm.status,
          event: {
            action: 'balance',
            merchant_no: this.setForm.merchant_no
          }
        }
        try {
          await auditExOrder(data).then((res: any) => {
            this.configID = res.transaction_id
            if (this.language === 'en') {
              this.$message({
                message: 'Operation is successful!',
                type: 'success'
              })
              this.dialogStatement = true
              this.getMerchantFundInfo()
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '操作成功!',
                type: 'success'
              })
              this.dialogStatement = true
              this.getMerchantFundInfo()
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '操作成功!',
                type: 'success'
              })
              this.dialogStatement = true
              this.getMerchantFundInfo()
            }
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  // 获取商户资金明细
  private merchantFundInfoList: any = []
  private async getMerchantFundInfo() {
    try {
      const data: any = {
        merchant_no: this.setForm.merchant_no,
        id: this.configID
      }
      await getTransaction(data).then((res: any) => {
        this.merchantFundInfoList = res.results
      })
    } catch (e) {
      this.back()
    }
  }

  mounted() {}
}
